import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'socialIcon',
  standalone: true
})
export class SocialIconPipe implements PipeTransform {
  transform(url: string): string {
    if (!url) return 'pi pi-link'; // ícone genérico

    const lower = url.toLowerCase();

    if (lower.includes('facebook.com')) return 'pi pi-facebook';
    if (lower.includes('instagram.com')) return 'pi pi-instagram';
    if (lower.includes('x.com') || lower.includes('twitter.com')) return 'pi pi-twitter';
    if (lower.includes('linkedin.com')) return 'pi pi-linkedin';
    if (lower.includes('youtube.com')) return 'pi pi-youtube';
    if (lower.includes('tiktok.com')) return 'pi pi-tiktok';
    if (lower.includes('whatsapp.com') || lower.startsWith('https://wa.me')) return 'pi pi-whatsapp';
    if (lower.includes('telegram.me') || lower.includes('t.me')) return 'pi pi-send';

    // se não for nenhuma rede reconhecida
    return 'pi pi-globe';
  }
}
